/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const paginatedPersonsDataSchema = z.object({
	data: z.array(
		z.object({
			id: z.string(),
			name: z.string().nullable(),
			primaryEmail: z.string().nullable(),
			primaryPhone: z.string().nullable(),
			candidacyCount: z.number(),
			lastAppliedAt: z.iso.datetime().nullable(),
			lastActivityAt: z.iso.datetime().nullable(),
			lastActivityLabel: z.union([
				z.literal('messaged'),
				z.literal('stage_moved'),
				z.literal('applied'),
				z.literal('interview'),
			]).nullable(),
			lastActivityCampaign: z.object({ id: z.string(), title: z.string() }).nullable(),
			lastActivityActorType: z.union([z.literal('recruiter'), z.literal('candidate'), z.literal('system')])
				.nullable(),
			lastActivityActorName: z.string().nullable(),
			skills: z.array(
				z.object({
					escoSkillId: z.string(),
					conceptUri: z.string(),
					label: z.string(),
					sources: z.array(
						z.object({ candidateId: z.string(), questionId: z.string(), optionId: z.string() }),
					),
				}),
			),
		}),
	),
	meta: z.object({ currentPage: z.number(), lastPage: z.number(), perPage: z.number(), total: z.number() }),
})

export type PaginatedPersonsDataSchema = z.infer<typeof paginatedPersonsDataSchema>
